import { Button, Tooltip } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { goNextFrame } from "../../../redux";
import { ReactComponent as LeftIcon } from "./arrow-left-double-line.svg";
import { iconSize } from "../../../config";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/ArrowLeft.svg";

export function LeftButton() {
  const dispatch = useDispatch();
  return (
    <Tooltip
      title={
        <span>
          Previous frame
          <br></br>(
          <kbd>
            <ArrowLeft />
          </kbd>
          )
        </span>
      }
    >
      <Button
        type="text"
        onClick={() => dispatch(goNextFrame())}
        icon={<LeftIcon width={iconSize} height={iconSize} />}
      />
    </Tooltip>
  );
}
